import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        userInfo: null, // 用户信息
        token: null,    // 登录 Token
        userFlag:null,  //用户类型 0:管理员 1:：评委  2：普通用户  3: 审批用户
        userId:null,
        isLoggedIn: false, // 登录状态
        showLoginModal: false , //登录窗口
        showTopNavbar: true
    }),

    actions: {
        // 保存用户信息到 Store 和本地存储
        setAuthData(data) {
            this.userInfo = data.userInfo;
            this.token = data.token;
            this.userFlag = data.userFlag;
            this.userId = data.userId;
            this.isLoggedIn = true;

            // 保存到 localStorage（可选）
            localStorage.setItem('token', data.token);
            localStorage.setItem('userFlag', data.userFlag);
            localStorage.setItem('userId', data.userId);
            localStorage.setItem('userInfo', JSON.stringify(data.userInfo));
        },

        // 清除登录信息
        clearAuthData() {
            this.userInfo = null;
            this.token = null;
            this.userFlag = null;
            this.userId = null;
            this.isLoggedIn = false;

            // 清除本地存储
            localStorage.removeItem('token');
            localStorage.removeItem('userFlag');
            localStorage.removeItem('userInfo');
            localStorage.removeItem('userId');
        },

        // 初始化时检查本地是否有登录状态
        checkAuth() {
            const token = localStorage.getItem('token');
            const userFlag = localStorage.getItem('userFlag');
            const userId = localStorage.getItem('userId');
            const userInfo = localStorage.getItem('userInfo');

            if (token && userInfo) {
                this.setAuthData({
                    token,
                    userFlag,
                    userId,
                    userInfo: JSON.parse(userInfo),
                });
            }
        },

        showLogin() { this.showLoginModal = true },
        hideLogin() { this.showLoginModal = false }
    },
});
